import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class DiscountsViewModel {
    ShowAlert:           (pTitle: string, pMessage: string) => void;
    BackToSignIn:        ()                                 => void;
    NewLoading:          (pMessage: string)                 => dmLoading;

    mlText:              MLText;
    app:                 mlBroker;
    ml:                  mlBroker;
    Hotel:               dmHotel;
    LangID:              number;

    InRefresh:           boolean;

    OfferTypes:          RQService.Pms.GetOfferTypeMemberDiscountsRow[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText              = pMLText;
        this.LangID              = this.mlText.GetLangID();
        this.app                 = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                  = this.mlText.GetBroker(
            'HotelAreaDiscounts'
        );

        this.Hotel               = pHotel;
        this.BackToSignIn        = pBackToSignIn;
        this.ShowAlert           = pShowAlert;
        this.NewLoading          = pNewLoading;

        this.InRefresh           = false;

        this.OfferTypes          = [];

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshDiscount(() => { loading.Dismiss(); });
        });
    }

    private refreshDiscount(pAction: () => void): void {
        if (this.InRefresh) { return; }

        let discountParams = RQParam.PmsGetOfferTypeMemberDiscountsParams();

        discountParams.HotelID = this.Hotel.HotelID;
        discountParams.LangID  = this.Hotel.LangID;

        RQService.Pms.GetOfferTypeMemberDiscounts(discountParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }
            
            let offerTypes = response.RQueryResult;

            this.OfferTypes.length = 0;
            
            for (let i = 0; i < offerTypes.length; i++) {
                let offerType = RQService.Pms.PopulateGetOfferTypeMemberDiscountsRow(
                    offerTypes[i]
                );
            
                console.log('ot row push');

                this.OfferTypes.push(offerType);
            }

            pAction();
        });
    }

    public SetAllowDiscount(
         event:      any
        ,pOfferType: RQService.Pms.GetOfferTypeMemberDiscountsRow
    ): void {
        console.log(event);

        let allow = event.value as boolean;

        pOfferType.AllowDiscount = (event.value) ? 1 : 0;
    };

    public SetPercentage(
         event:      any
        ,pOfferType: RQService.Pms.GetOfferTypeMemberDiscountsRow
    ): void {
        console.log(event);

        let percentage = event.value as number;

        pOfferType.DiscountPercentage = percentage;
    };

    public SetOfferTypeMemberDiscount(
        pOfferType: RQService.Pms.GetOfferTypeMemberDiscountsRow
    ): void {
        let discountParams = RQParam.PmsSetOfferTypeMemberDiscountParams();

        discountParams.HotelID            = this.Hotel.HotelID;
        discountParams.OfferTypeID        = pOfferType.OfferTypeID;
        discountParams.AllowDiscount      = pOfferType.AllowDiscount;
        discountParams.DiscountPercentage = pOfferType.DiscountPercentage;

        if (!discountParams.DiscountPercentage) { discountParams.DiscountPercentage = 0; }

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            RQService.Pms.SetOfferTypeMemberDiscount(discountParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshDiscount(() => { loading.Dismiss(); })
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/discounts/xv-discounts.ts